import { Container, Col, Row } from "reactstrap";
import styles from "./styles.module.scss";
import JobSearch from "@sourceflow-uk/job-search";
import "@sourceflow-uk/job-search/dist/bundle.css";
import useJobs from "@/hooks/useJobs";
import JobCard from "@/components/JobCard";

// JOB FILTERS
import sectors from "@/.sourceflow/jobs-Sectors.json";
import jobsTypes from "@/.sourceflow/jobs-job_types.json";
import workType from "@/.sourceflow/jobs-work_type.json";
import baseSalaryRange from "@/.sourceflow/jobs-uk_base_salary_range.json";
import locations from "@/.sourceflow/jobs-job_locations.json";

export const JobsFeed = ({ className, title, subTitle, heading }) => {

  const totalJobs = useJobs({ limit: null });

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <JobSearch
          options={{
            urlFilters: {
              mode: "active",
              jobCategories: [
                sectors,
                jobsTypes,
                workType,
                baseSalaryRange,
                locations,
              ],
              pushToHistoryOnSearch: true,
              changeURLOnFilterChange: true,
            },
            jobsUrl: "/jobs",
            jobsPerPage: 10,
            searchFilters: true,
            submitDestination: null,
            performInitialSearch: true,
            searchSubmitButton: false,
            searchInput: false,
            searchFiltersOptions: {
              showResetSearchButton: true,
              topLevelCategoryOrder: ["Sectors", "Salary Range", "Region", "Job Type", "Work Type"],
              filterShowCount: false,
              initialFilterOpenState: false,
              exclude: {
                // Consultants
                Consultants: true,
                // Training and Apprenticeships
                "de2f2c85-d4eb-4cc4-9ce9-8b660662411a": true,
                // Featured Employers
                "902834a4-3efa-4ad1-98b4-ebdf7755cdbe": true,
              },
              categorySort: {
                // Sectors
                "54182828-5365-45cf-ac98-4f86ec1177cd": {
                  key: "name",
                  direction: "asc",
                },
                // Region
                "3259bf19-6cd5-41c8-81cc-5217e80df31c": {
                  key: "name",
                  direction: "asc",
                },
                // Job Type
                "d0dac92e-18c8-4aca-818b-62daa86e3e59": {
                  key: "name",
                  direction: "asc",
                },
                // Work Type
                "53aa6eb5-9fcb-43a1-a6cb-db497c151bfd": {
                  key: "name",
                  direction: "asc",
                },
                "Salary Range": function (a, b) {
                  a = parseInt(a.name.match(/^£([\d,]+)/)[1].replace(",", ""));
                  b = parseInt(b.name.match(/^£([\d,]+)/)[1].replace(",", ""));

                  if (a > b) return 1;
                  if (a < b) return -1;
                  return 0;
                },
              },
            },
            searchResults: ({ results }) =>
              results?.length >= 1 ? (
                <>
                  <div className="mb-4">
                    {title && <h2 className={heading}>Jobs Found</h2>}
                    <p className="text-muted">
                      {subTitle || `Showing ${totalJobs?.length} vacancies`}
                    </p>
                  </div>
                  <Row>
                    {results.map(({ job }) => (
                      <Col xs={12} key={job.id} className="mb-4">
                        <JobCard
                          {...job}
                          published_at={job.published_at * 1000}
                        />
                      </Col>
                    ))}
                  </Row>
                </>
              ) : (
                <>
                  <p>
                    Sorry, we couldn't find any jobs matching your search.
                    Please try removing some filters or searching for something
                    else.
                  </p>
                </>
              ),
          }}
        />
      </Container>
    </section>
  );
};

export default JobsFeed;
